<form *ngIf="isLoading()" [formGroup]="form" novalidate fxLayout="column" class="content-form">
  <mat-form-field fxFlex="100" class="frmField">
    <input
      placeholder="{{ 'ADMIN.MASTER.STORES.QUERY_FILTER' | pTranslate }}"
      matInput
      name="name"
      type="text"
      formControlName="query"
      attr.data-test-id="query"
      (input)="emitForm()"
    />
  </mat-form-field>

  <!-- DINAMIC COMBOS SELECTED -->
  <div *ngFor="let tag of selectedTags" fxLayout="row wrap" fxLayoutGap="32px" class="test-dynamic-tag-select-wrapp">
    <mat-form-field fxFlex="calc(100%+0px)" fxFlex.gt-xs="calc(50%-32px)" class="mt-16">
      <mat-select
        [formControlName]="getFormControlName(tag)"
        [placeholder]="getPlaceholder(tag)"
        (closed)="_lookUp = ''; _lookUpB = ''"
        class="_select-no-overflow test-dynamic-tag-select"
        (selectionChange)="emitForm()"
        [multiple]="multipleSelection"
        [attr.data-test-id]="getTagName(tag)"
      >
        <!-- multiple -->
        <ng-container *ngIf="tag.parentId">
          <ng-container *ngTemplateOutlet="tagWithParentIncluded1; context: { tag: tag }"></ng-container>
        </ng-container>

        <ng-container *ngIf="!tag.parentId">
          <ng-container *ngTemplateOutlet="tagNoParentIncluded1; context: { tag: tag }"></ng-container>
        </ng-container>
        <!-- CONTENIDO DE COMBO SIMPLE -->
        <ng-template #tagNoParentIncluded1 let-tag="tag">
          <div class="lookUpInput">
            <input
              [placeholder]="getPlaceholderLookUp(tag)"
              [value]="_lookUp"
              (input)="_lookUp = $event.target.value"
              (keydown)="$event.stopPropagation()"
            />
          </div>

          <ng-container *ngFor="let option of tag.values">
            <span [hidden]="!contains(option.value, _lookUp)">
              <mat-option [value]="option.id" color="accent">{{ option.value }}</mat-option>
            </span>
          </ng-container>
        </ng-template>

        <!-- CONTENIDO DE COMBO AGRUPADOS -->
        <ng-template #tagWithParentIncluded1 let-tag="tag">
          <div class="lookUpInput">
            <input
              [placeholder]="getPlaceholderLookUp(tag)"
              [value]="_lookUpB"
              (input)="_lookUpB = $event.target.value"
              (keydown)="$event.stopPropagation()"
            />
          </div>

          <mat-optgroup *ngFor="let group of tag.groups" [label]="group.value">
            <ng-container *ngFor="let option of group.values">
              <span [hidden]="!contains(option.value, _lookUpB)">
                <mat-option [value]="option.id" color="accent">{{ option.value }}</mat-option>
              </span>
            </ng-container>
          </mat-optgroup>
        </ng-template>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- AGREGAR ATRIBUTOS -->
  <div fxLayout="row" class="mt-20 mb-20">
    <div fxFlex fxLayoutAlign="end start">
      <button
        mat-icon-button
        color="accent"
        matTooltip="{{'ADMIN.MASTER.STORES.ADD_ATRIBUTE_BTN' | pTranslate}}"
        [disabled]="isDisabledAddtags()"
        (click)="openNewtagDialog({ selectAll: true, list: avaibleTags })"
        data-test-id="add_tags"
      >
        <span class="material-icons font-size-30">add_circle_outline</span>
        <!-- {{ 'PR.STP.RULES.ADD_ATTRIBUTE_BTN' | pTranslate }} -->
      </button>
    </div>
  </div>
</form>

<div class="spinner-container" *ngIf="!isLoading()">
  <custom-loader></custom-loader>
</div>
